module.exports = __webpack_public_path__ + "static/media/cacao3.127ad611.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pioricost-fruit/cacao/cacao3.jpeg
// module id = 48
// module chunks = 0